module.exports = __webpack_public_path__ + "static/media/Weisston-Script.94bb5fe6.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Weisston-Script.eot
// module id = 2991
// module chunks = 70